export default __webpack_public_path__ + "static/media/empty-debit.f33ce379.svg";